export const selectMachineSearch = (state: { machine: any; }) => state.machine.searchValue;
export const selectMachineCurrentSelection = (state: { machine: any; }) => state.machine.currentSelection;
export const selectMachineCurrentName = (state: { machine: any; }) => state.machine.currentName;
export const selectMachineSelectedTab = (state: { machine: any }) => state.machine.currentSelectedTab;
